import React from 'react'
import styled from '@emotion/styled'

import theme from '../styles/theme'

const LinesCurtainWrapper = styled.div`
  display: flex;
  width: 100%;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;

  > div {
    ${p =>
      p.active &&
      `transform: scaleX(1);
       transition-delay: 0s`};
  }
`

const Column = styled.div`
  ${p => (p.width ? `width: ${p.width}` : 'flex: 1')};
  height: 100%;
  background-color: ${theme.colors.grey_1100};
  transform-origin: left center;
  transform: scaleX(0);
  transition: 0.5s 0.5s transform;
`

const LinesCurtain = ({ active, ...props }) => (
  <LinesCurtainWrapper active={active} {...props}>
    <Column width="10%" />
    <Column />
    <Column />
    <Column width="10%" />
  </LinesCurtainWrapper>
)

export default LinesCurtain
